import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeMinimum: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVolumeMinimum"><Path d="M15.4648 10C15.8052 10.5884 16 11.2715 16 12.0001C16 12.7287 15.8052 13.4118 15.4648 14.0001M1.5 7.5H6L12.5 3.75V20.25L6 16.5H1.5V7.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVolumeMinimum;
